module.exports = __webpack_public_path__ + "static/media/Fortem.1b2f0910.jpg";